import { render, staticRenderFns } from "./JdihCharts.vue?vue&type=template&id=ae1611c6&scoped=true&"
import script from "./JdihCharts.vue?vue&type=script&lang=js&"
export * from "./JdihCharts.vue?vue&type=script&lang=js&"
import style0 from "./JdihCharts.vue?vue&type=style&index=0&id=ae1611c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae1611c6",
  null
  
)

export default component.exports